// eslint-disable-next-line import/order
import classNames from "classnames";
import useTranslate from "hooks/useTranslate";
import { WheelType } from "../../../types/Wheel";
import { wheelSetClass } from "../../../helpers/class";

import "./styles.sass";

export type AttemptProps = {
  attempts: number;
  type: WheelType;
};

const Attempt = (props: AttemptProps) => {
  const { attempts, type } = props;

  const t = useTranslate();

  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  const componentClass = classNames(wheelSetClass("Attempt", type), {
    banger:
      VITE_APP_PROJECT_NAME === "banger" &&
      type !== WheelType.CRAZY_TIME &&
      type !== WheelType.GATES_OLYMPUS &&
      type !== WheelType.SWEET_BONANZA &&
      type !== WheelType.ROULETTE,
  });

  const numbersClass = classNames(
    wheelSetClass("Attempt-block__number", type, "", false),
    {
      banger:
        VITE_APP_PROJECT_NAME === "banger" &&
        type !== WheelType.SWEET_BONANZA &&
        type !== WheelType.GATES_OLYMPUS &&
        type !== WheelType.CRAZY_TIME &&
        type !== WheelType.ROULETTE,
    },
  );

  return (
    <div className={componentClass}>
      <div className={wheelSetClass("Attempt-block", type)}>
        <div className={wheelSetClass("Attempt-block__title", type)}>
          {t("wheel.attempts")}
        </div>
        <div className={numbersClass}>{attempts}</div>
      </div>
    </div>
  );
};

export default Attempt;
